
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import Card from '@/components/Card.vue'
import { defineComponent, ref, computed, onMounted, reactive, toRefs, createVNode, h, provide } from 'vue'
import { useStore } from 'vuex'
import Form from './Form.vue'
import HistoryForm from './HistoryForm.vue'
import { Modal } from 'ant-design-vue'
import Swal from 'sweetalert2'

export default defineComponent({
  components: {
    Card,
    Form,
    HistoryForm
  },
  setup () {
    const form = reactive({
      id: '',
      sales: '',
      adjustments: '',
      deliveries: '',
      closing_stock: '',
      site_id: '',
      site_name: '',
      grade: '',
      tank: '',
      deliveries_remark: '',
      sales_remark: '',
      other_remark: '',
      opening_stock: 0,
      closing_stock_remark: '',
      site_product_id: '',
      date: '',
      adjustment_entries: [],
      book_stock: '',
      variance: ''
    })
    provide('inventory', form)
    const form_action = ref('save')
    const visible = ref(false)
    const visible_history = ref(false)
    const store = useStore()
    const site_id = ref('')

    const fields = ref([
      {
        title: 'Site Name',
        dataIndex: 'site.site_name',
      },
      {
        title: 'Tank Name',
        dataIndex: 'site_product.tank.name',
      },
      {
        title: 'Product Name',
        dataIndex: 'site_product.product.product_name',
      },
      {
        title: 'Date',
        dataIndex: 'inventory_date',
      },
      {
        title: 'Opening Stock',
        dataIndex: 'opening_stock',
      },
      {
        title: 'Deliveries',
        dataIndex: 'deliveries',
      },
      {
        title: 'Adjustment',
        dataIndex: 'adjustments',
      },
      {
        title: 'Sales',
        dataIndex: 'sales',
      },
      {
        title: 'Closing Stock',
        dataIndex: 'closing_stock',
      },
      {
        title: 'Book Stock',
        dataIndex: 'book_stock',
      },
      {
        title: 'Variance',
        dataIndex: 'variance',
      },
      {
        title: 'Action',
        dataIndex: 'inventory',
        slots: {customRender: 'inventory'},
        align: 'center'
      },
    ])

    const getAllRetailerSites = () => {
      store.dispatch('Option/getAllRetailerSites')
    }

    const index = (payload: any) => {
      store.dispatch('RetailerInventories/index', payload)
    }

    const filterRecord = (payload: any) => {
      index({selected_site: site_id.value, payload})
    }

    const editRecord = (record: any) => {
      form_action.value = 'update'
      const {
        id,
        site_product_id,
        sales,
        adjustments,
        deliveries,
        closing_stock,
        site_id,
        site_name,
        grade,
        tank,
        deliveries_remark,
        sales_remark,
        other_remark,
        opening_stock,
        closing_stock_remark,
        date,
        book_stock,
        variance
      } = toRefs(form)
      id.value = record.id
      sales.value = record.sales
      adjustments.value = record.adjustments
      closing_stock.value = record.closing_stock
      deliveries.value = record.deliveries
      site_id.value = record.site_id
      site_product_id.value = record.site_product.id
      site_name.value = record.site.site_name
      grade.value = record.site_product.product.product_name
      tank.value = record.site_product.tank.name
      deliveries_remark.value = record.deliveries_remark
      sales_remark.value = record.sales_remark
      other_remark.value = record.other_remark
      closing_stock_remark.value = record.closing_stock_remark
      opening_stock.value = record.opening_stock
      date.value = record.inventory_date
      book_stock.value = record.book_stock
      variance.value = record.variance
      visible.value = true
    }

    const historyRecord = (record: any) => {
      const {site_product_id, site_id} = toRefs(form)
      site_product_id.value = record.site_product.id
      site_id.value = record.site_id
      visible_history.value = true
    }

    const postRecord = (record: any) => {
      if (!record.sales || !record.closing_stock || !record.deliveries) {
        missingRequiredData(record)
      } else {
        confirmPost(record)
      }
    }

    const missingRequiredData = (payload: any) => {
      if(payload.sales == null){
        Swal.fire({
          title: 'Missing required field',
          text:  'Sales input is required',
          icon: 'info',
          confirmButtonText: 'OK',
        })
      }else if(payload.closing_stock == null){
        Swal.fire({
          title: 'Missing required field',
          text:  'Closing Stock input is required',
          icon: 'info',
          confirmButtonText: 'OK',
        })
      }else if(payload.deliveries == null){
        Swal.fire({
          title: 'Missing required field',
          text:  'Delivery input is required',
          icon: 'info',
          confirmButtonText: 'OK',
        })
      }
    }

    const confirmPost = (payload = {}) => {
      Swal.fire({
        title: 'Confirm Post',
        text: 'Are you sure you want to POST this Daily Inventory?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          store
              .dispatch('RetailerInventories/store', payload)
          index({selected_site: site_id.value, payload})
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            // isLoading.value = false
            // index({selected_site: site_id.value})
        }
      });
      Modal.confirm({
        title: 'Confirm Post',
        icon: createVNode(ExclamationCircleOutlined),
        content: createVNode('div', {style: 'color:red;'}, 'Are you sure you want to POST this Daily Inventory?'),
        onOk () {
          store
              .dispatch('RetailerInventories/store', payload)
          index({selected_site: site_id.value, payload})
        },
        class: 'test',
      })
    }

    const handleSaving = (record: any) => {
      updateRecord(record)
    }

    const updateRecord = (payload = {}) => {
      store
          .dispatch('RetailerInventories/update', payload)
          .then(() => (
              visible.value = false,
                  index({selected_site: site_id.value, payload})
          ))
    }

    const onChange = (payload: any) => {
      site_id.value = payload
      index({
        selected_site: site_id.value
      })
    }

    const items = computed(() => store.getters['RetailerInventories/items'])
    const all_retailer_sites = computed(() => store.getters['Option/all_retailer_sites'])

    onMounted(() => {
      getAllRetailerSites()
      let record = items.value
      if (record.data) {
        record.data.length = 0
      }

    })

    return {
      fields,
      all_retailer_sites,
      items,
      visible,
      form,
      form_action,
      visible_history,
      onChange,
      editRecord,
      handleSaving,
      postRecord,
      historyRecord,
      filterRecord
    }
  }

})
